import React from 'react'
import {Grid, GridColumn, GridRow} from 'semantic-ui-react'
import PDFDownloadByState from './PDFDownloadByState'
import Modal from '../../common/Modal'
import useLocalForm from '../../../hooks/useLocalForm'
import {DEFAULT_GROUP_TYPE} from '../../../constant/GROUP_TYPES'
import ControlledFormField from "../../common/ControlledFormField";

export default function PlanMemberAlternateSubmissionModal({trigger}) {
  const {state: formState, dispatch: setFormState, reset} = useLocalForm({
    usState: {value: ''},
    groupNumber: {
      value: '',
      dirty: '',
      error: '',
      transform: (v) => v.replace(/[^a-zA-Z0-9]/g, '').toUpperCase()
    },
    groupType: {value: DEFAULT_GROUP_TYPE},
    error: null
  })


  const onChange = (e) => {
    setFormState({
      key: `${e.target.id}.value`,
      value: formState[e.target.id].transform ? formState[e.target.id].transform(e.target.value) : e.target.value
    })
  }

  const onBlur = (e) => {
    setFormState({
      key: `${e.target.id}.dirty`,
      value: true
    })
  }


  const content = () => {
    return <Grid centered container divided='vertically'>
      <GridRow>
        <GridColumn width={13} textAlign='center'>
          You may choose to type answers into the form(s) before printing or simply print a blank form(s) to complete by
          hand. Forms must be signed and dated, then mailed to the address provided on the form.
        </GridColumn>
      </GridRow>
      <ControlledFormField
        id='groupNumber'
        attachedLabel='G000'
        label='Group ID Number'
        maxLength={4}
        value={formState.groupNumber.value}
        onChange={onChange}
        onBlur={onBlur}
      />
      <PDFDownloadByState state={formState} setState={setFormState}/>
    </Grid>
  }

  return <Modal
    id='plan-member-paper-form'
    trigger={trigger}
    onClose={reset}
    closeIcon
    closeOnDimmerClick
    trackingName='/paper/plan-member'
  >
    {content()}
  </Modal>
}